import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import AiAssistantChat from '../AiAssistantChat/aiAssistantChat';
import { api as aiAssistantApi } from '../../../actions/AiAssistant/aiAssistantActions';
import { loadPopupWidth, savePopupWidth } from '../../../utils/AiAssistant/aiAssistantStorage';
import './aiAssistantSidePopup.scss';

const DEFAULT_WIDTH = 400;
const MIN_WIDTH = 320;
const MAX_WIDTH = 900;

export default function AiAssistantSidePopup({ sData, showSidePopup = false }) {
  const [width, setWidth] = useState(() => loadPopupWidth() ?? DEFAULT_WIDTH);
  const [isDragging, setIsDragging] = useState(false);
  const popupRef = useRef(null);

  const handleResizeMouseDown = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = width;
    setIsDragging(true);
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'ew-resize';

    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, startWidth + (startX - moveEvent.clientX)));
      popupRef.current.style.width = `${newWidth}px`;
    };

    const onMouseUp = (upEvent) => {
      const finalWidth = Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, startWidth + (startX - upEvent.clientX)));
      savePopupWidth(finalWidth);
      setWidth(finalWidth);
      setIsDragging(false);
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  return (
    <div
      ref={popupRef}
      className={`ai-popup${showSidePopup ? ' open' : ''}`}
      style={{ width: `${width}px` }}
    >
      <div className={`ai-popup-resize-handle${isDragging ? ' dragging' : ''}`} onMouseDown={handleResizeMouseDown} />
      <div className="ai-popup-content">
        <AiAssistantChat sData={sData} isVisible={showSidePopup} onClose={aiAssistantApi.hideSidePopup} />
      </div>
    </div>
  );
}

AiAssistantSidePopup.propTypes = {
  sData: PropTypes.object.isRequired,
  showSidePopup: PropTypes.bool,
};
